import {TLinkDto} from 'shared/types/links';

type TFormatLinkToPassFunctionArgs = {
   value: any;
   record: Record<string, any>;
   useTableValueAsTitleInLink?: boolean;
}

export const formatLinkToPass = ({
    record,
    value: rawValue,
    useTableValueAsTitleInLink,
}: TFormatLinkToPassFunctionArgs) => {
    let linkToPass: TLinkDto = {...rawValue};
    if (useTableValueAsTitleInLink && linkToPass.position?.column) {
        linkToPass = {
            ...rawValue,
            linkProperties: {
                ...rawValue.linkProperties,
                title: record[linkToPass.position.column],
            },
        };
    }
    return linkToPass;
};
